import React from 'react';

import { SalaryBar } from 'src/app/views/components/SalaryBar';
import { useConfig } from 'src/app/views/hooks/useConfig';
import type { SuggestedSalary } from 'src/types/salaryTypes';

import { formatLabel } from './utils/format-label';

export const PayRangeBar = ({
  suggestedSalary,
  userInputMinMax,
}: {
  suggestedSalary: SuggestedSalary;
  userInputMinMax: { minInput?: number; maxInput?: number };
}) => {
  const locale = useConfig().getLocale();
  if (!suggestedSalary) {
    return null;
  }
  const { min, max, averageMin, averageMax, currency } = suggestedSalary;
  const { minInput, maxInput } = userInputMinMax;

  return (
    <SalaryBar
      scaleLabelOne={formatLabel(min, { locale, currency })}
      scaleLabelTwo={formatLabel(averageMin, { locale, currency })}
      scaleLabelThree={formatLabel(averageMax, { locale, currency })}
      scaleLabelFour={formatLabel(max, { locale, currency })}
      scaleValueMax={max}
      scaleValueMin={min}
      selectedValueMax={maxInput || 0}
      selectedValueMin={minInput || 0}
    />
  );
};
